function hexToRgb() {
  var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var h = hex.replace('#', '');
  var shortened = h.length === 3;
  var step = shortened ? 1 : 2;
  var bIndex = shortened ? 2 : 4;

  var parse = function parse(from) {
    return parseInt(h.slice(from, from + step).repeat(shortened ? 2 : 1), 16);
  };

  return "rgba(".concat(parse(0), ", ").concat(parse(step), ", ").concat(parse(bIndex), ", ").concat(opacity, ")");
}

export default hexToRgb;